import React, { Component } from 'react';
import { browserHistory } from 'react-router';

export default class Modal extends Component {
    constructor(props) {
        super(props);

        this._closeModal = this._closeModal.bind(this);
        this._openModal = this._openModal.bind(this);
    }

    _closeModal() {
        $('#'+this.props.modalId).modal("hide");
    }

    _openModal() {
        $('#'+this.props.modalId).modal("show");
    }

    componentDidMount() {
      $('#'+this.props.modalId).on('hidden.bs.modal', (e) => {
        if (this.props.onClose) {
          this.props.onClose();
        }
      });
    }

    componentWillReceiveProps(nextProps) {
      if ( this.props.open !== nextProps.open) {
        nextProps.open ? this._openModal() : this._closeModal();
      }
    }

    render() {
        let children = (this.props.children)
                        ? React.cloneElement(this.props.children, {
                            closeModal: this._closeModal
                          })
                        : '';

        return (
            <div className="modal fade" id={this.props.modalId} role="dialog" aria-labelledby={this.props.modalId} aria-hidden="true">
                <div
                  className={this.props.size ? `modal-dialog modal-${this.props.size}` : "modal-dialog"}
                  role="document"
                  style={this.props.style}
                >
                    { typeof this.props.children === 'function' ? this.props.children(this._closeModal.bind(null)) : children}
                </div>
            </div>
        )
    }
}

Modal.defaultProps = {
  style: {}
};



// WEBPACK FOOTER //
// ./src/Common/Modal.js